import PropTypes from 'prop-types';

import Container from 'components/container';
import Anchor from 'components/typography/anchor';
import wordmark from 'images/logo.svg';
import { header, columnView, logo, wrapView, link } from './header.module.scss';

const Header = ({ children, siteTitle }) => (
  <div className={header}>
    <Container>
      <header>
        <nav className={columnView}>
          <Anchor label="Resistbot Home" href="/">
            <img className={logo} src={wordmark} alt={siteTitle} />
          </Anchor>
          <ul className={wrapView}>
            <li>
              <Anchor className={link} href="/">
                Home
              </Anchor>
            </li>
            <li>
              <Anchor className={link} href="/petitions">
                Petitions
              </Anchor>
            </li>
            <li>
              <Anchor className={link} href="/donate">
                Donate
              </Anchor>
            </li>
            <li>
              <Anchor className={link} href="/guide">
                Guide
              </Anchor>
            </li>
            <li>
              <Anchor className={link} href="/about">
                Help
              </Anchor>
            </li>
            <li>
              <Anchor className={link} href="/news">
                News
              </Anchor>
            </li>
          </ul>
        </nav>
        {children}
      </header>
    </Container>
  </div>
);

Header.propTypes = {
  siteTitle: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default Header;
